import ReactDOM from "react-dom/client";
import "./assets/styles/global.scss";
import App from "./App";
import { Provider } from "react-redux";
import { AuthProvider } from "./contexts/AuthContext";
import store from "./store";
import moment from "moment";
import "moment/locale/ru";

// import eruda from "eruda";

// eruda.init();

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(() => console.log('SW registered'))
      .catch((err) => console.log('SW registration failed', err));
  });
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
moment.locale("ru");

root.render(
  <Provider store={store}>
    <AuthProvider>
      <App />
    </AuthProvider>
  </Provider>
);
